namespace Matrix.Workflow {
    export class QueueTypeColumns {
        static columnsKey = 'Workflow.QueueType';
    }
}
